function interregional() {
	const parentEl = document.querySelector('.popup-interregional')
	//! Region section
	let regions = parentEl.querySelectorAll('.region')
	let cities = parentEl.querySelectorAll('.cities')

	regions.forEach((region, id) => {
		region.setAttribute('data-region', region.querySelector('a').textContent)
		cities[id].setAttribute('data-region', region.querySelector('a').textContent)
		region.onclick = () => {
			regions.forEach(el => el.classList.remove('region--active'))
			region.classList.add('region--active')
			cities.forEach(el => el.setAttribute('style', 'display: none;'))
			cities[id].removeAttribute('style')
		}
	})

	//! Search section
	let search = parentEl.querySelector('.Search')
	let searchInp = search.querySelector('input')
	let searchList = search.querySelector('.Search__list')
	let notFound = search.querySelector('.not-found')

	let searchCities = search.querySelectorAll('.Search__item:not(.not-found)')

	search.onclick = e => {
		if (e.target.closest('.Search__form')) {
			!e.target.closest('.Search__svg--active') ? search.classList.add('Search--active') : search.classList.remove('Search--active')
		} else {
			searchInp.removeAttribute('style')
			search.classList.remove('Search--active')
		}
	}
	searchInp.onmousedown = searchInp.oninput = () => {
		searchInp.removeAttribute('onfocusin')
		if (searchInp.value) {
			searchList.removeAttribute('style')
			searchInp.removeAttribute('style')
			searchCities.forEach(item => {
				if (item.textContent.indexOf(searchInp.value.toLowerCase()) > -1 || item.textContent.indexOf(searchInp.value.toUpperCase()) > -1) {
					item.removeAttribute('style')
					notFound.setAttribute('style', 'display: none;')
					item.setAttribute('data-show', '')
				} else {
					item.setAttribute('style', 'display: none;')
					item.removeAttribute('data-show')
				}
				if (searchCities.length !== searchList.querySelectorAll('[style]:not(.not-found)').length) {
					notFound.setAttribute('style', 'display: none;')
				} else {
					notFound.removeAttribute('style')
				}
			})
			searchList.querySelectorAll('[data-show]')[searchList.querySelectorAll('[data-show]').length - 1].style.border = 'none'
		} else {
			searchList.setAttribute('style', 'display: none;')
			searchInp.setAttribute('style', 'border-bottom: 1px solid #9aca3c; border-radius: 5px;')
		}
	}
}

const initinterregional = () => {
	let openBtn = document.querySelector('[href="#popup-interregional"]')
	openBtn.onclick = () => {
		interregional()
	}
}
